import 'apps/hiring/styles/components/evaluate.scss';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'library/util/core-router';
import Query from 'apps/hiring/util/query';
import { applicantsQuery, applicantsParseQuery } from 'apps/hiring/queries/openings/applicantsQuery';
import { employeesQuery, employeesParseQuery} from 'apps/hiring/queries/openings/employeesQuery';
import { CancelToken, isCancel } from 'axios';
import { resolve } from 'library/helpers/path-resolver';
import { jsonToInputParams } from 'library/util/graph';
import HiringQuery from 'apps/hiring/util/query';
import withData from 'util/hoc/with-data';
import EvaluateTargetList from 'apps/hiring/components/evaluate-target-list';
import EvaluateApplicantList from 'apps/hiring/components/evaluate-applicant-list';
import EvaluateEmployeeList from 'apps/hiring/components/evaluate-employee-list';
import Cheese from 'apps/hiring/components/cheese';
import AddTarget from 'apps/hiring/components/add-target';
import EditTarget from 'apps/hiring/components/edit-target';
import EvaluateLoading from 'apps/hiring/components/loading/evaluate';
import PencilSvg from 'library/icons/pencil.svg';
import ReadMore from 'library/components/read-more';
import { strip_tags } from 'library/helpers/text';

class Evaluate extends React.Component {
  static propTypes = {
    graph_update: PropTypes.func.isRequired,
    history: PropTypes.object,
    reload_graph: PropTypes.func.isRequired,
    match: PropTypes.object,
    graph_data: PropTypes.object,
    graph_loading: PropTypes.bool
  }

  state = {
    selected: {},
    selectedEmployee: null,
    selectedEmployeeName: null,
    selectedApplicantName: null,
    active_applicant: null,
    loading: false,
  }

  static getDerivedStateFromProps (props) {
    return {
      selected: resolve(props, 'graph_data/target_groupings', []).find(t=>t.id===Number(resolve(props, 'match/params/target', '')))
    };
  }

  componentWillUnmount() {
    if (this._cancelToken) {
      this._cancelToken.cancel();
    }
  }

  handleCollapsable = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  onTargetReorder = (targets) => {
    this.props.graph_update({
      opening: {
        closed: resolve(this.props, 'graph_data/closed', false),
        name: resolve(this.props, 'graph_data/opening_name'),
        applications: {
          results: resolve(this.props, 'graph_data/applications', [])
        },
        employees: {
          results: resolve(this.props, 'graph_data/employees', [])
        },
        target_groupings: {
          results: targets,
          pagination: resolve(this.props, 'graph_data/target_pagination', {})
        }
      }
    });
  }

  loadMatch = async () => {
    this.setState({
      loading: true
    });
    if (this._cancelToken) {
      this._cancelToken.cancel();
    }

    this._cancelToken = CancelToken.source();

    try {
      const { data } = await Query(`
        {
          opening (id: ${resolve(this.props, 'match/params/id', '')}) {
            applications (surveyed:true, limit:1000) {
              results {
                id
                match (target_id: ${resolve(this.state, 'selected/id', '')})
              }
            }
          }
        }
      `, null, {cancelToken: this._cancelToken.token});

      const applications = resolve(data, 'opening/applications/results', []);

      this.props.graph_update({
        opening: {
          closed: resolve(this.props, 'graph_data/closed', false),
          name: resolve(this.props, 'graph_data/opening_name'),
          applications: {
            results: resolve(this.props, 'graph_data/applications', []).map(a=>{
              a.match = resolve(applications.find(b=>b.id===a.id), 'match', null);
              return a;
            })
          },
          employees: {
            results: resolve(this.props, 'graph_data/employees', [])
          },
          target_groupings: {
            results: resolve(this.props, 'graph_data/target_groupings', []),
            pagination: resolve(this.props, 'graph_data/target_pagination', {})
          }
        }
      });
    } catch (e) {
      if (isCancel(e)) {
        return;
      }
      console.error(e);
    }
    this.setState({
      loading: false
    });
  }

  setSelectedTarget = (id) => {
    if (!id) return;
    this.props.history.push(`/hiring/openings/${resolve(this.props, 'match/params/id', '')}/evaluate/${id}`);
  }

  handleApplicantSelect = (id) => {
    const app = resolve(this.props, 'graph_data/applications', []).find(c=> c.id == id);
    this.setState({
      active_applicant: id===this.state.active_applicant?null:id,
      selectedApplicantName: id===this.state.active_applicant? null : `${app.user.first_name} ${app.user.last_name}`
    });
  }

  renderFromName = () => {
    let applicant = null;
    if (this.state.active_applicant) {
      applicant = resolve(this.props, 'graph_data/applications', []).find(a=>a.id===this.state.active_applicant);
    }

    return (
      <Fragment>
        <span>
          {
            applicant
              ? [resolve(applicant, 'user/first_name', null),resolve(applicant, 'user/last_name', null)].filter(c=>c).join(' ')
              : resolve(this.props, 'graph_data/opening_name', '')
          }
        </span>
        {
          applicant
            ? null
            : ' candidates'
        }
      </Fragment>
    );
  }

  onEmployeeRemove = async (id) => {
    this.setState({
      loading: true
    });
    try {
      const params = {
        node_id: Number(resolve(this.props, 'match/params/id', null)),
        user_id: Number(id),
        user_type: 'Employee'
      };
      await HiringQuery(`
        mutation {
          remove_user_from_node (${jsonToInputParams(params)}) {
            success
          }
        }
      `);

      await this.props.reload_graph(true, true);
    } catch (e) {
      console.error(e);
    }
    this.setState({
      loading: false
    });
  }

  onEmployeeAdd = async (id) => {
    try {
      const params = {
        node_id: Number(resolve(this.props, 'match/params/id', null)),
        user_id: Number(id),
        user_type: 'Employee'
      };
      await HiringQuery(`
        mutation {
          create_node_policy (${jsonToInputParams(params)}) {
            success
          }
        }
      `);

      await this.props.reload_graph(true, true);
    } catch (e) {
      console.error(e);
    }
  }

  onEmployeeSelect = (val) => {
    const emp = resolve(this.props, 'graph_data/employees', null).find(c=> c.id == val.id);
    this.setState({
      selectedEmployee: resolve(this.state.selectedEmployee, 'id', null) === val.id ? null : val,
      selectedEmployeeName: resolve(this.state.selectedEmployee, 'id', null) === val.id ? null : `${emp.first_name} ${emp.last_name}`
    });
  }


  handleAddTargets = async (targets) => {
    try {
      const params = {
        ids: targets.map(t=>t.id),
        connectable_id: Number(resolve(this.props, 'match/params/id', null)),
        connectable_type: 'node'
      };

      await HiringQuery(`
        mutation {
          connect_targets (${jsonToInputParams(params)}) {
            errors,
            success,
            target_groupings {
              name,
              finalized
            }
          }
        }
      `);

      await this.props.reload_graph(true);

      this.setSelectedTarget(resolve(targets, '0/id', null));
    } catch (e) {
      console.error(e);
    }
    try {
      const params = {
        ids: targets.map(t=>t.id),
        connectable_id: Number(resolve(this.props, 'match/params/id', null)),
        connectable_type: 'node'
      };

      await HiringQuery(`
        mutation {
          connect_targets (${jsonToInputParams(params)}) {
            errors,
            success,
            target_groupings {
              name,
              finalized
            }
          }
        }
      `);

      await this.props.reload_graph(true);

      this.setSelectedTarget(resolve(targets, '0/id', null));
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const {
      match,
      graph_data,
      graph_loading,
      reload_graph
    } = this.props;

    const {
      selected,
      loading,
      active_applicant,
      selectedEmployee,
    } = this.state;

    if (graph_loading) {
      return (
        <div className="hiring-evaluate">
          <EvaluateLoading />
        </div>
      );
    }

    return (
      <div className="hiring-evaluate">
        {
          selected
            ? (
              <Fragment>
                <EvaluateTargetList
                  opening
                  openingId={resolve(match, 'params/id', null)}
                  onTargetReorder={this.onTargetReorder}
                  reload_graph={reload_graph}
                  targets={resolve(graph_data, 'target_groupings', [])}
                  handleAddTargets={this.handleAddTargets}
                  selectedTarget={selected}
                  setSelectedTarget={this.setSelectedTarget}
                  disabled={resolve(graph_data, 'closed', false)===true}
                />
                <div className="hiring-evaluate-body">
                  <div className="hiring-evaluate-sidebar">
                    <h4>Applicants</h4>
                    <EvaluateApplicantList
                      query={applicantsQuery}
                      parseQuery={applicantsParseQuery}
                      match={match}
                      activeTarget={resolve(match, 'params/target', 0)}
                      loading={loading}
                      openingId={resolve(match, 'params/id', null)}
                      openingName={resolve(graph_data, 'opening_name', '')}
                      active_applicant={active_applicant}
                      onApplicantSelect={this.handleApplicantSelect}
                      reload={reload_graph}
                      tags={
                        active_applicant
                          ?[
                            {
                              id: active_applicant,
                              tag: <span className="hiring-evaluate-sidebar-item-tag-color-auxilary-1" />
                            }
                          ]
                          :[]
                      }
                      disabled={resolve(graph_data, 'closed', false)===true}
                    />
                    <h4>Employees</h4>
                    <EvaluateEmployeeList
                      key={'employees'}
                      query={employeesQuery}
                      parseQuery={employeesParseQuery}
                      match={match}
                      reload={reload_graph}
                      loading={loading}
                      active={resolve(selectedEmployee, 'id', null)}
                      onEmployeeSelect={this.onEmployeeSelect}
                      onAdd={this.onEmployeeAdd}
                      onRemove={this.onEmployeeRemove}
                      node_id={resolve(this.props, 'match/params/id', null)}
                      tags={[
                        ...resolve(graph_data, 'employees', []).map(e=>({
                          id: e.id,
                          tag: <span className="hiring-evaluate-sidebar-item-tag-color-tertiary" />
                        })),
                        ...(selectedEmployee?[{
                          id: resolve(selectedEmployee, 'id', null),
                          tag: <span className="hiring-evaluate-sidebar-item-tag-color-auxilary-2" />
                        }]:[])
                      ]}
                      disabled={resolve(graph_data, 'closed', false)===true}
                    />
                  </div>
                  <div className="hiring-evaluate-content">
                    <div className="hiring-evaluate-content-header">
                      <div className="hiring-evaluate-content-header-inner">
                        <h1>
                          {this.renderFromName()} matched to the <span>{ resolve(selected, 'name', '') } </span> Target
                          <EditTarget
                            node_id={resolve(graph_data, 'opening/id', null)}
                            disabled={resolve(graph_data, 'closed', false)===true}
                            component="button"
                            className="button-noborder-theme"
                            id={resolve(selected, 'id', null)}
                          >
                            <PencilSvg />
                          </EditTarget>
                        </h1>
                        { strip_tags((resolve(selected, 'description', null)||'')).length > 0
                          ?
                          (<ReadMore defaultHeight={61}>
                            <p dangerouslySetInnerHTML={{__html: (resolve(selected, 'description', null)||'').replace(new RegExp(`(\\<\\/?p\\s?\\>|\\<p\\s?\\/\\>)`, 'g'), '')}} />
                          </ReadMore>
                          )
                          :null
                        }
                      </div>
                    </div>
                    <Cheese
                      withRanges
                      withKey
                      assessments={[
                        resolve(graph_data, 'employees', []).map(e=>resolve(e, 'assessment/id', '')).filter(c=>c),
                        resolve(resolve(graph_data, 'applications', []).find(a=>a.id===active_applicant), 'assessment/id', null),
                        resolve(selectedEmployee, 'assessment_id', null)
                      ]}
                      target={this.state.selected}
                      selectedEmployeeName={this.state.selectedEmployeeName}
                      selectedApplicantName={this.state.selectedApplicantName}
                    />
                  </div>
                </div>
              </Fragment>
            )
            : (
              <div className="hiring-evaluate-cta">
                {
                  resolve(graph_data, 'target_groupings/0/id', false)
                    ? (
                      <Redirect to={`/hiring/openings/${resolve(match, 'params/id', null)}/evaluate/${resolve(graph_data, 'target_groupings/0/id', '')}`} />
                    )
                    : null
                }
                <h1>
                  No Targets
                </h1>
                <AddTarget activeTargets={resolve(graph_data, 'target_groupings', [])} onTargets={this.handleAddTargets} />
              </div>
            )
        }
      </div>
    );
  }
}

Evaluate.parseQueryData = (data) => ({
  closed: resolve(data, 'opening/closed', false),
  opening_name: resolve(data, 'opening/name', ''),
  applications: resolve(data, 'opening/applications/results', []),
  employees: resolve(data, 'opening/employees/results', []),
  target_groupings: resolve(data, 'opening/target_groupings/results', []),
  target_pagination: resolve(data, 'opening/target_groupings/paination', {}),
  organization: resolve(data, 'organization', null)
});

Evaluate.cache_key = ({ match }) => `evaluate_targets_${match.params.id}`;

const PossibleMatch = (match) => {
  if (resolve(match, 'params/target', false)) {
    return `match(target_id:${Number(resolve(match, 'params/target', null))}),`;
  }
  return '';
};

Evaluate.dependantPropPath = 'match/params/target';
Evaluate.query = async (token, { match }) => (
  HiringQuery(`
  {
    organization {
      id
    }
    opening (id: ${match.params.id}) {
      name,
      closed,
      applications (surveyed:true, limit:1000) {
        results {
          id,
          status,
          resume_url,
          ${PossibleMatch(match)}
          user {
            first_name,
            last_name,
            id,
            email
          }
          assessment (completed: true) {
            id
            validity_score,
            validity_errors,
            scored
          }
        }
      }
      employees: users (limit: 1000, has_surveyed: true) {
        results {
          first_name,
          last_name,
          id,
          ${PossibleMatch(match)}
          assessment (completed: true) {
            id,
            validity_score,
            validity_errors,
            scored
          }
        }
      }
      target_groupings (limit: 100) {
        pagination {
          limit,
          offset,
          total
        }
        results {
          id,
          name,
          finalized,
          description,
          targets {
            id
            characteristic {
              description,
              name
            }
            percentile_range {
              end,
              start
            }
          }
        }
      }
    }
  }
  `)
);

export default withData(Evaluate, __LANGUAGE__);
